import React, {useState, useEffect} from 'react'
import {inject, observer} from 'mobx-react'
import {getMonitorList} from '@apis'
import ChartBlock from '@components/chartBlock'
import MonitorItem from '@components/monitorItem'

function RenderMonitorItem({
  url = '',
  accessToken = ''
}) {
  const src = `https://open.ys7.com/ezopen/h5/iframe?url=${url}&autoplay=1&accessToken=${accessToken}`
  return (
    <iframe
      src={src}
      width="100%"
      height="100%"
      allowfullscreen
    />
  )
}

const RealtimeMonitor = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {brokerId} = userInfo

    const [monitorList, setMonitorList] = useState([])
    const [curLeftIndex, setCurLeftIndex] = useState()
    const [monitorUrl, setMonitorUrl] = useState()
    const [time, setTime] = useState(0)

    async function queryMonitorList() {
      const params = {
        brokerId,
        pageNo: 1,
        pageSize: 9999,
      }
      const res = await getMonitorList(params)
      if (res && res.data) {
        setMonitorList(res.data)
        if(res.data[0]) {
          setCurLeftIndex(res.data[0].monitorAccessToken)
          setMonitorUrl(res.data[0].url)
        }
      }
    }

    if(time == 0) {
      if(monitorList.length) {
        const timer = setInterval(function() {
          for(let i=0; i<monitorList.length; i++) {
            if(monitorList[i].url == monitorUrl) {
              if(i+1 < monitorList.length) {
                setMonitorUrl(monitorList[i+1].url)
                setCurLeftIndex(monitorList[i+1].monitorAccessToken)
              } else {
                setMonitorUrl(monitorList[0].url)
                setCurLeftIndex(monitorList[0].monitorAccessToken)
              }
              setTime(1)
            }
          }
        }, 60*1000)
      }
    }

    useEffect(() => {
      queryMonitorList()
    }, [])
    return (
      <ChartBlock title="实时监控">
        {
          monitorList.length ? (
            <MonitorItem
              url={monitorUrl}
              accessToken={curLeftIndex}
            />
          ) : null
        }
      </ChartBlock>
    )
  })
)

export default RealtimeMonitor
